<template>
  <div class="insurance">
    <van-dialog
      v-model="show"
      title="中国人民财产保险股份有限公司儿童个人信息保护规则"
    >
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >更新日期：2023年5月29日</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >生效日期：2023年6月29日</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >中国人民财产保险股份有限公司（以下简称
          “人保财险”或“我们”）深知个人信息对儿童及其监护人的重要性，也感谢儿童及其监护人对人保财险的信任。为了更好地保护儿童信息，除<strong>《中国人民财产保险股份有限公司隐私政策》</strong>外，人保财险还将通过<strong>《中国人民财产保险股份有限公司儿童个人信息保护规则》</strong>（以下简称“本政策”）向儿童及其监护人说明人保财险将会如何收集、存储、保护、使用及对外提供儿童的个人信息（以下简称“儿童信息”），并说明儿童及其监护人所享有的权利和需履行的义务。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >儿童监护人特别说明：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果您是儿童的监护人，请您仔细阅读和选择是否同意本声明。人保财险希望请您与我们共同保护儿童的个人信息，教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经您同意的情况下，不向任何网络产品和服务提供者提供任何个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >儿童特别说明：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果你是14周岁以下的未成年人，你需要和你的监护人一起仔细阅读本声明，并在征得你的监护人同意后，使用人保财险的产品、服务或向人保财险提供信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本规则为在<strong>《中国人民财产保险股份有限公司隐私政策》</strong>基础上制定的特别规则，与<strong>《中国人民财产保险股份有限公司隐私政策》</strong>如有不一致之处，以本规则为准；本规则未载明之处，则参照适用<strong>《中国人民财产保险股份有限公司隐私政策》</strong>。为了维护用户的合法权益，儿童应当在其监护人的指导下使用人保财险的服务。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如您在阅读本政策过程中有任何疑问或其他与儿童信息相关事宜的，我们为您提供了专门的反馈渠道，具体参见<strong>《中国人民财产保险股份有限公司隐私政策》</strong>中“如何联系我们”章节，我们会尽快为您作出解答。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您可以根据以下索引阅读相应章节，进一步了解本政策的具体约定：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□我们收集儿童的哪些个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□我们如何使用儿童的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□我们如何对外提供、转让或公开披露儿童的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□您如何管理儿童的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□我们如何存储和保护儿童的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□如何联系我们</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >□我们收集儿童的哪些个人信息</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >人保财险严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们将会通过用户提供的身份证号码识别用户是否为14周岁以下的未成年人，如识别该用户为14周岁以下的未成年人的，我们将按照法律法规的规定，在获得儿童监护人同意之后才允许儿童继续使用相关产品或服务。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们在识别用户为14周岁以下未成年人时，可能会收集儿童监护人的姓名、证件类型、证件号码、手机号码等信息，并使用这些信息与您联系，验证您与您被监护儿童之间的监护关系，征得您对处理被监护儿童信息的同意。我们也可能会将您的账户与儿童账户进行关联，以便保护您和您被监护儿童的个人信息权益。如产品或服务涉及到上传头像等功能，我们强烈建议您指导儿童在使用我们产品和服务的过程中不要上传真实的本人肖像照片等信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在儿童使用产品或服务过程中，我们会继续收集相关信息，具体请查阅<strong>《中国人民财产保险股份有限公司隐私政策》</strong>“我们收集哪些您的个人信息”一节，详细了解我们收集的儿童个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如我们超出已获得您同意的范围处理您或被监护儿童的个人信息，我们将再次告知您，并征得您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在浏览页面、搜索查询等业务场景中，我们无法准确识别所收集和处理的个人信息是否属于儿童个人信息，我们将按照<strong>《中国人民财产保险股份有限公司隐私政策》</strong>收集和处理用户的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >□我们如何使用儿童的个人信息</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们将收集您所监护的儿童的信息用于以下用途：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >验证儿童和儿童监护人身份；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（2）<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;
          </span></span
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >《中国人民财产保险股份有限公司隐私政策》</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >中“我们如何使用您的个人信息”所述个人信息使用目的。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如我们需要超出上述收集范围收集您所监护的儿童的个人信息，我们将再次告知您，并征得您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >□我们如何对外提供、转让或公开披露儿童的个人信息</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）对外提供</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们会严格按照上述授权条款使用和保护您的个人信息，除以下情形外，我们不会向任何第三方提供您的个人信息：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）政府、监管和司法机关要求共享等法律法规规定的情况下，我们将依法向其提供您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（2）转让</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们目前不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；我们将向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，接收方不得超出上述权限处理您的个人信息，除非重新取得您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会向您告知接收方的名称或姓名与联系方式，并要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（2）公开披露</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会公开披露您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）获得您明确同意后；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）基于法律要求的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >□您如何管理儿童的个人信息</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在儿童用户使用我们的产品和服务期间，为了您和儿童可以更加便捷地行使您和儿童对儿童信息的查询、复制、更正、补充、删除等各项权利，您可以通过查询<a
            ><strong>《中国人民财产保险股份有限公司隐私政策》</strong></a
          >“您的权利”一节，详细了解您如何管理儿童个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您也可以通过我们提供的联系方式，提出行使权利的请求和申请，或者反馈和咨询相关信息。我们会在核实反馈的问题后及时与您联系。请您理解，在核实过程中，我们可能需要您提供姓名、证件类型、证件号码、手机号，以便在完成验证您与儿童的监护关系等前提事项后继续响应您的需求。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >被监护儿童年满14周岁后，有权自行管理其账户。如果儿童用户选择自行管理其账户，您将无法继续访问或控制其账户。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >□我们如何存储和保护儿童的个人信息</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们在中华人民共和国境内收集和产生的儿童的个人信息将存储在中华人民共和国境内。</span
        ><span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >并且仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存儿童的个人信息。当儿童或其监护人进行删除或账号注销后，我们将对儿童的个人信息进行立即删除。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >为保障儿童的信息安全，我们采用业界标准的安全防护措施保护儿童提供的个人信息，防止数据遭到泄露、篡改或丢失。例如，在应用与服务之间交换数据时受SSL加密保护；对官网提供https安全浏览方式；使用技术确保数据的保密性；使用受信赖的保护机制防止数据遭遇恶意攻击；部署访问控制机制，确保只有授权人员才可访问个人信息。</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >此外，也请您妥善保护您所监护的儿童的个人信息，如您发现您所监护的儿童的账户及密码发生泄露，请您立即联络我们的客服，以便我们采取相应措施。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >□如何联系我们</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们设置了个人信息保护的专门部门/专门岗位人员。如果您对本隐私政策有任何疑问或任何相关的投诉、意见，请通过拨打95518与我们联系，一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过您所在管辖区的法院或政府相关管理机构等外部途径寻求解决方案。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >个人信息保护的专门岗位人员联系方式： 95518</span
        >
      </p>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="less" scoped>
.insurance {
  /deep/.van-dialog__header {
    color: #323233;
    font-weight: 700;
    font-size: 17px;
  }
  /deep/.van-dialog__content {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    max-height: 60vh;
    padding: 8px 24px 26px 24px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    text-align: center;
    word-wrap: break-word;
    -webkit-overflow-scrolling: touch;
  }
}
</style>